import React from 'react';
import { InfoIcon } from 'lucide-react';
import { TESTIMONIALS_ARE_ILLUSTRATIVE } from '../../data/reviews';
import { ReviewsList } from '../ReviewsList';
export function TestimonialsSection() {
  return <section aria-labelledby="testimonios-title" className="overflow-hidden bg-cream py-12 sm:py-24" data-id="element-394" data-mp="1ruwbjkj7643o">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-395" data-mp="1mvjniwglaqzi">
        <div className="mx-auto max-w-2xl text-center" data-id="element-396" data-mp="1muql27onynn6">
          {TESTIMONIALS_ARE_ILLUSTRATIVE && <p className="mx-auto inline-flex items-center gap-1.5 rounded-full border border-beige-300 px-3 py-1 text-[11px] font-medium text-ink/55" data-id="element-397" data-mp="1dvwlq9jy7j5x">
              <InfoIcon className="h-3 w-3" aria-hidden="true" data-id="element-398" data-mp="18xldg39axgpt" />
              Testimonios ilustrativos
            </p>}
          <h2 id="testimonios-title" className="mt-4 font-serif text-[1.9rem] leading-tight text-petrol-800 text-balance sm:text-5xl" data-id="element-399" data-mp="1403aqulvnxq9">
            Lo que dicen quienes <span className="italic text-terra-500" data-id="element-400" data-mp="2y9neruvsm10v">ya lo conocieron</span>
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-ink/70 sm:mt-5 sm:text-lg" data-id="element-401" data-mp="1t8bzy1gxcgm8">
            Recursos pensados para hacer más práctica la preparación y organización de tus consultas.
          </p>
        </div>

        <ReviewsList data-id="element-402" data-mp="1jdtx0yjc0p3h" />
      </div>
    </section>;
}